import { render } from "./MinistryExecutionForm.vue?vue&type=template&id=4a04654b"
import script from "./MinistryExecutionForm.vue?vue&type=script&lang=js"
export * from "./MinistryExecutionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__